module.exports = __webpack_public_path__ + "img/kv-bg.05a73e87.jpg";